import React from "react";
import "./MoreWeOfferStyle.scss";
import { moreWeOfferTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "components/Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const MoreWeOfferSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="more-we-offer-section">
      <div className="more-we-offer-wrap">
        <SectionHeading>{moreWeOfferTextContent.headingText}</SectionHeading>

        <div className="more-we-offer-box">
          <div className="cards-grid">
            {moreWeOfferTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-header">
                  <div className="icon-box">
                    <img src={section.iconSrc} alt="Image" />
                  </div>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>
              </div>
            ))}
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={moreWeOfferTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoreWeOfferSection;
